import * as React from "react";

import * as R from "ramda";

import GenModal from "../Gen/Modal";

import { findCustomFields } from "../../src/activities";

import GenButton from "../Gen/Button";

interface DocCustomizeActivitiesModalProps {
  currentDocument: CurrentDocument;
  currentVersion: CurrentVersion;
  currentUser: CurrentUser;
  currentRoleDefinition: CurrentRoleDefinition;
  currentDocumentSetDocumentRelation?: CurrentDocumentSetDocumentRelation;
  displayState: DisplayState;
  possibleActivities: Array<CombineActivitiesReturnType>;
}

export default function DocCustomizeActivitiesModal(props: DocCustomizeActivitiesModalProps) {
  const {
    displayState,
    possibleActivities,
    currentDocumentSetDocumentRelation,
  } = props;

  const {
    openMenu,
  } = displayState;

  const [customEntriesUpdates, setCustomEntriesUpdates] = React.useState<Record<string, string>>({});

  if (!openMenu || openMenu.name !== "CUSTOMIZE_ACTIVITIES_MODAL") { return null; } // TODO: GET RID OF?

  const activity = possibleActivities.find((activity) => activity.id === openMenu.activityId);

  if (!activity) { return; }

  const activityCustomEntries = activity.custom_entries;

  const customFields = findCustomFields(activity.content);

  const compiledCustomEntries = Object.entries(customFields).map((customField) => {
    const fieldKey = customField[0];
    return {
      key: fieldKey,
      defaultValue: customField[1],
      value: fieldKey in customEntriesUpdates ? customEntriesUpdates[fieldKey] : activityCustomEntries[fieldKey] || "",
    };
  });

  return (
    <GenModal open>
      <div className="gen-modal-panel">
        <h1>Customize Activity</h1>

        {compiledCustomEntries.map((customField) => {
          return (
            <div>
              <label>{customField.key}</label>
              <textarea
                value={customField.value}
                placeholder={customField.defaultValue}
                onChange={(event) => (setCustomEntriesUpdates({ ...customEntriesUpdates, [customField.key]: event.target.value }))}
              />
            </div>
          );
        })}

        <div className='flex gap-2'>
          <GenButton
            name="Save"
            highlighted
            onClick={() => {
              const cleanedCustomEntries = R.reject(R.equals(""), {...activityCustomEntries, ...customEntriesUpdates});

              if ("document_set_document_activity" in activity) {
                activity.document_set_document_activity._actions.setEditFields({custom_entries: cleanedCustomEntries});
                activity.document_set_document_activity._actions.update();
              } else if("document_activity" in activity) {
                activity.document_activity._actions.setEditFields({custom_entries: cleanedCustomEntries});
                activity.document_activity._actions.update();
              }

              displayState.setOpenMenu(undefined);
            }}
          />
          <GenButton
            name="Cancel"
            highlighted
            onClick={() => displayState.setOpenMenu(undefined)}
          />
        </div>
      </div>
    </GenModal>
  );
}
